/* src/app/pages/directorio-contacto/directorio-contacto.component.css */
.sort-icon.rotated {
  transform: rotate(180deg);
}
.search-cont {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 19px;
}
.title-directorio {
  font-family: "Gotham Bold";
  font-size: 25px;
  line-height: 30px;
  color: #323E48;
  margin-bottom: 30px;
}
.search-text {
  font-family: "Gotham Book";
  font-size: 18px;
  line-height: 25px;
  color: #323E48;
  margin-bottom: 42px;
}
.sort-icon {
  width: 7.42px;
  height: 11.13px;
  margin-left: 10px;
  vertical-align: middle;
}
.table {
  border: 1px solid #E7E9E9;
  margin: 0;
  table-layout: fixed;
}
.table td {
  word-break: break-word;
  height: 75px;
  padding: 15px 16px;
}
.table th {
  font-family: "Gotham Medium" !important;
  font-size: 15px;
  color: #363F40;
  padding: 15px 16px;
}
.table-content {
  font-family: "Gotham Book";
  font-size: 15px;
  line-height: 18px;
  color: #323E48;
}
.col-estado {
  max-width: 443px;
  width: 100%;
  background-color: #E7E9E9;
  cursor: pointer;
  font-weight: normal !important;
}
.col-gerente {
  max-width: 443px;
  width: 100%;
  background-color: #E7E9E9;
  cursor: pointer;
  font-weight: normal !important;
}
.col-contacto {
  max-width: 404px;
  width: 100%;
  background-color: #E7E9E9;
  font-weight: normal !important;
}
.input-wrapper {
  position: relative;
  width: 100%;
  height: 71px;
  margin-bottom: 20px;
}
.custom-input {
  border: none !important;
  background-color: #F4F7F8;
  border-radius: 8px 8px 0 0 !important;
  border-bottom: 1px solid #5B6670 !important;
  width: 100%;
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 30.5px !important;
  padding-bottom: 1.5px;
  font-family: "Gotham Medium" !important;
  color: #323E48;
  font-size: 15px;
  line-height: 100%;
  height: 50px;
}
.custom-textarea {
  border: none !important;
  background-color: #F4F7F8;
  border-radius: 8px 8px 0 0 !important;
  border-bottom: 1px solid #5B6670 !important;
  width: 100%;
  padding-left: 20px !important;
  padding-right: 20px !important;
  padding-top: 25px !important;
  font-family: "Gotham Medium" !important;
  color: #323E48;
  font-size: 15px;
  line-height: 100%;
  height: 70px;
  margin: 0;
}
.custom-input:focus,
.custom-textarea:focus {
  outline: none !important;
  box-shadow: none !important;
}
.floating-label {
  position: absolute;
  left: 20px;
  top: 14px;
  color: #323E48;
  font-size: 15px;
  line-height: 20px;
  font-family: "Gotham Medium";
  pointer-events: none;
  transition: 0.2s ease all;
}
.input-wrapper input:focus + .floating-label,
.input-wrapper input:not(:placeholder-shown) + .floating-label,
.input-wrapper textarea:focus + .floating-label,
.input-wrapper textarea:not(:placeholder-shown) + .floating-label {
  top: 2.5px;
  font-size: 15px;
  line-height: 20px;
  font-family: "Gotham Book";
  color: #5B6670;
  padding: 0;
}
#message {
  height: 165px;
}
.format-btn {
  width: 30px;
  height: 30px;
  border-color: #EB0029;
  color: #EB0029;
}
.format-btn:hover {
  background-color: #EB0029;
  color: #FFF;
}
.custom-radio {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  border: 1px solid #5B6670;
  background-color: white;
  position: relative;
  cursor: pointer;
  vertical-align: middle;
  transition: all 0.2s ease;
  display: inline-block;
}
.custom-radio:checked {
  background-color: #EB0029;
  border: 2px solid white;
  box-shadow: 0 0 0 1px #EB0029;
}
.btn-enviar {
  font-family: "Gotham Medium";
  font-weight: 500;
  font-size: 15px;
  color: #fff;
  background-color: #EB0029;
  border: none;
  padding: 10px 24px;
  border-radius: 4px;
  transition: background-color 0.2s ease, box-shadow 0.1s ease;
  width: 126px;
  height: 45px;
  gap: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.btn-enviar:hover {
  background-color: #E50028;
}
.btn-enviar:active {
  background-color: #E30028;
  box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.3);
}
.btn-enviar:disabled {
  background-color: #CFD2D3 !important;
  border-color: #CFD2D3 !important;
  color: #A2A9AD !important;
  pointer-events: none;
}
.btn-cancelar {
  font-family: "Gotham Medium";
  font-weight: 500;
  font-size: 15px;
  color: #323E48;
  background-color: white;
  border: 1px solid #323E48;
  padding: 10px 24px;
  border-radius: 4px;
  transition: all 0.2s ease;
  width: 126px;
  height: 45px;
  gap: 20px;
}
.btn-cancelar:hover,
.btn-cancelar:active,
.btn-cancelar:focus {
  color: #EB0029;
  border-color: #EB0029;
  background-color: white !important;
  box-shadow: none !important;
}
.formulario-container {
  background-color: #EBF0F2;
  padding: 50px 0px;
  border-radius: 8px;
  max-width: 1330px;
  margin: 0 auto;
}
.from-title {
  font-family: "Gotham Bold";
  font-size: 25px;
  color: #323E48;
  margin-top: 29px;
}
.texto-from {
  font-family: "Gotham Book";
  font-size: 18px;
  text-align: center;
  max-width: 460px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 0;
  color: #5B6670;
}
.text-campoo {
  font-family: "Gotham Book";
  font-size: 15px;
  line-height: 18px;
  color: #5B6670;
}
.text-camp-title {
  font-family: "Gotham Book";
  font-size: 15px;
  color: #5B6670;
}
.text-from {
  font-family: "Gotham Medium";
  font-size: 15px;
  color: #323E48;
}
.custom-input:-webkit-autofill,
.custom-input:-webkit-autofill:hover,
.custom-input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px white inset !important;
  -webkit-text-fill-color: inherit !important;
  transition: background-color 5000s ease-in-out 0s;
}
.floating-group {
  width: 450px;
  position: relative;
}
.floating-control {
  height: 89px !important;
  resize: none;
}
.custom-select-wrapper {
  width: 100%;
  position: relative;
  font-family: "Gotham Medium";
  margin-bottom: 20px;
  height: 71px;
}
.custom-select-display {
  width: 100%;
  height: 50px;
  border-bottom: 1px solid #5B6670;
  border-radius: 6px 6px 0 0;
  background-color: #F4F7F8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  cursor: pointer;
  position: relative;
}
.custom-select-text {
  height: 43px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.custom-select-label {
  font-size: 15px;
  line-height: 18px;
  color: #323E48;
  font-family: "Gotham Medium";
  position: absolute;
  left: 0;
  background-color: #F4F7F8;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s ease;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-select-label.float {
  font-size: 13px;
  font-family: "Gotham Book";
  color: #5B6670;
  top: 0;
  background-color: #F4F7F8;
  transform: translateY(0);
}
.selected-value {
  font-size: 15px;
  line-height: 20px;
  color: #323E48;
  font-family: "Gotham Medium";
  margin-top: 26.5px;
}
.custom-select-options {
  position: absolute;
  top: 52px;
  left: 0;
  width: 100%;
  border-radius: 5px 5px 6px 6px;
  background-color: #F4F7F8;
  box-shadow: 0 2px 6px rgba(0 0, 0, 0.15);
  z-index: 3;
  margin-top: 6px;
  padding: 0;
  list-style: none;
  overflow-y: auto;
  max-height: calc(50px * 10);
}
.custom-select-options li {
  padding: 15px 20px;
  font-size: 15px;
  color: #5B6670;
  cursor: pointer;
  font-family: "Gotham Book";
  height: 50px;
  display: flex;
  align-items: center;
}
.custom-select-options li:hover {
  background-color: #F4F7F8;
  color: #323E48;
}
.arrow {
  transition: transform 0.3s ease;
  transform-origin: center;
  width: 15px;
  height: 7.16px;
}
.gx-2 {
  --bs-gutter-x: 1.5rem;
}
.form-check-label {
  text-align: left;
  font-size: 15px;
  line-height: 20px;
  font-family: "Gotham Book";
  color: #5B6670;
}
.btn-wrapper {
  display: flex;
  align-items: flex-end;
  height: 44px;
}
.btn {
  padding: 10px 30px;
  background-color: #EB0029;
  color: #FFFFFF;
  border-radius: 4px;
  display: flex;
  align-items: center;
  gap: 10px;
  height: 44px;
  width: 146px;
  border: none;
}
.btn-text {
  font-family: "Gotham Medium";
  font-size: 15px;
  line-height: 18px;
}
.btn-icon {
  display: flex;
  width: 24px;
  height: 24px;
  padding: 0px 3.915px 0px 3px;
  justify-content: center;
  align-items: center;
}
.btn:hover {
  background-color: #E30028;
}
.btn:active {
  background-color: #E30028 !important;
  color: #FFFFFF !important;
  box-shadow: inset 0 2px 4px rgba(104, 1, 1, 0.3) !important;
}
.custom-select-displaay {
  width: 259px;
  height: 50px;
  border-bottom: 1px solid #5B6670;
  border-radius: 6px 6px 0 0;
  background-color: #F4F7F8;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  cursor: pointer;
  position: relative;
}
.custom-select-texto {
  height: 43px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  position: relative;
}
.custom-select-labeel {
  font-size: 15px;
  line-height: 18px;
  color: #323E48;
  font-family: "Gotham Medium";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  transition: all 0.2s ease;
  pointer-events: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.custom-select-label.float {
  font-size: 13px;
  font-family: "Gotham Book";
  color: #5B6670;
  top: 0;
  transform: translateY(0);
}
.selected-valuee {
  font-size: 15px;
  line-height: 20px;
  color: #323E48;
  font-family: "Gotham Medium";
  margin-top: 18px;
}
.custom-select-optionss {
  position: absolute;
  top: 47px;
  left: 0;
  width: 259px;
  border-radius: 1px 1px 1px 1px;
  background-color: #F4F7F8;
  box-shadow: 0 0px 0px rgba(0, 0, 0, 0.15);
  z-index: 3;
  margin-top: 4px;
  padding: 8px;
  list-style: none;
  overflow-y: hidden;
  height: 300px;
}
.custom-select-optionss li {
  padding: 8px 12px;
  cursor: pointer;
  font-size: 15px;
  color: #323E48;
  font-family: "Gotham Medium";
  border-radius: 4px;
  transition: background-color 0.2s ease;
  list-style: none;
}
.custom-select-optionss li:hover {
  background-color: #e0e7ea;
}
.empty-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  text-align: center;
  width: 100%;
  min-height: 300px;
  margin: 0 auto;
  font-family: "Gotham Medium";
  color: #5B6670;
  border: 1px solid #E7E9E9;
}
.empty-image-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.empty-image-container img {
  width: 130px;
  height: 130px;
  margin-bottom: 20px;
}
.empty-title {
  font-size: 18px;
  line-height: 25px;
  font-family: "Gotham Medium";
  color: #5B6670;
  margin-bottom: 10px;
  padding: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
}
.empty-subtitle {
  font-size: 15px;
  line-height: 25px;
  padding: 0;
  color: #5B6670;
  font-family: "Gotham Book";
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.custom-select-optionss {
  max-height: 300px;
  overflow-y: auto;
}
.btn-detalle {
  display: flex;
  color: #EB0029;
  font-size: 13px;
  cursor: pointer;
  font-family: "Gotham Medium";
  line-height: 16px;
}
.paginador-wrapper {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 75px;
  border: 1px solid #E7E9E9;
  border-top: 0;
}
.paginador-container {
  display: flex;
  align-items: center;
  height: 36px;
  gap: 30px;
  font-family: "Gotham Medium";
  color: #5B6670;
  font-size: 13px;
  line-height: 18px;
}
.paginador-select {
  display: flex;
  gap: 30px;
}
.text-selectFilas {
  display: flex;
  align-items: center;
  word-break: break-word;
}
.select-filas {
  width: 81px;
  height: 32px;
  background-color: #F4F7F8;
  border: none;
  border-radius: 4px;
  padding: 7px 12px 7px 23px;
  font-family: "Gotham Medium";
  font-size: 13px;
  line-height: 18px;
  color: #5B6670;
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background-image: url("data:image/svg+xml,%3Csvg width='12' height='7' viewBox='0 0 12 7' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M1 1L6 6L11 1' stroke='%235B6670' stroke-width='2'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 15px center;
  background-size: 12px;
}
.select-filas:focus {
  outline: none;
  box-shadow: none;
}
.paginador-botones {
  display: flex;
  flex-wrap: wrap;
}
.paginador-botones button {
  background-color: transparent;
  border: none;
  padding: 0;
  cursor: pointer;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.paginador-botones button:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}
.paginador-botones img {
  width: 100%;
  height: 100%;
}
.btn-close:focus {
  outline: none !important;
  box-shadow: none !important;
}
.directorio-container {
  padding: 40px 56px;
}
@media (max-width: 473.5px) {
  .directorio-container {
    padding: 40px 16px;
  }
}
.search-gerente {
  margin: 0;
  padding: 0;
}
.th.td {
  border-left: #E7E9E9 1px;
  border-right: #E7E9E9 1px;
}
.close-button {
  position: absolute;
  top: 5px;
  right: 5px;
  padding: 0;
  border: none;
  background: transparent;
  cursor: pointer;
}
.close-button img {
  width: 100%;
  height: 100%;
  display: block;
}
.close-button:focus,
.close-button:focus-visible {
  outline: none;
  box-shadow: none;
}
.form-text {
  width: 100%;
  margin: 0;
  padding: 0;
  height: 14px;
}
.select-indicator {
  font-family: "Gotham Book";
  font-size: 13px;
  line-height: 14px;
  color: #5B6670;
  margin: 0;
}
.form-check {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 0;
  padding: 0;
  height: 20px;
}
.check-options {
  display: flex;
  justify-content: start;
  gap: 40px;
  height: 20px;
  margin-top: 20px;
  flex-wrap: wrap;
}
@media (max-width: 470px) {
  .check-options {
    gap: 10px;
  }
}
.modal-body {
  display: flex;
  justify-content: center;
}
.custom-input:-webkit-autofill,
.custom-input:-webkit-autofill:hover,
.custom-input:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0px 1000px #F4F7F8 inset !important;
  -webkit-text-fill-color: #323E48 !important;
  transition: background-color 5000s ease-in-out 0s;
}
input.form-control:-webkit-autofill {
  -webkit-box-shadow: 0 0 0 1000px #F4F7F8 inset !important;
  -webkit-text-fill-color: #323E48 !important;
}
.custom-textarea:-webkit-autofill,
.custom-textarea:-webkit-autofill:hover,
.custom-textarea:-webkit-autofill:focus {
  -webkit-box-shadow: 0 0 0 1000px #F4F7F8 inset !important;
  -webkit-text-fill-color: #323E48 !important;
  font-family: "Gotham Medium" !important;
  transition: background-color 0s ease-in-out 0s;
}
.modal-static .modal-dialog {
  transform: none !important;
}
.form-modal {
  max-width: 720px;
  width: 100%;
  margin: auto;
}
form {
  width: 100%;
}
.modal-custom-content {
  height: 608px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}
.modal-custom-content .modal-header {
  flex-shrink: 0;
  position: sticky;
  top: 0;
  z-index: 2;
}
.modal-custom-content .modal-body {
  overflow-y: auto;
  flex-grow: 1;
  overflow-y: scroll;
  scrollbar-width: none;
  -ms-overflow-style: none;
}
.buttons-wrapper {
  text-align: center;
  display: flex;
  justify-content: center;
  gap: 10px;
}
.scroll-bottom-padding {
  height: 20px;
  flex-shrink: 0;
}
.floating-group.error .custom-wrapper {
  border-bottom-color: #EB0029;
}
.floating-group.error label.floating-label,
.floating-group.error .floating-label,
.floating-group.error .floating-label.float {
  color: #EB0029 !important;
}
.floating-group.error .floating-label::after {
  color: #EB0029;
}
.helper-error,
.text-danger {
  color: #EB0029;
  font-size: 12px;
  line-height: 14px;
  margin-top: 7px;
  font-family: "Gotham Book";
}
.custom-input {
  border: none;
  border-bottom: 1px solid #ccc;
  border-radius: 0;
  padding: 8px 4px;
  box-shadow: none;
}
.search-spinner {
  width: 100px;
  height: 100px;
}
.textArea-label {
  background-color: #F4F7F8;
}
/*# sourceMappingURL=/banorte/__host/inmuebles/Inmuebles/directorio-contacto.component.css.map */
